import React, {useCallback, useEffect, useRef, useState} from 'react';

// components
import MainTable from '../../designComponents/tables/MainTable';
import FlexMainWrapper, {Wrapper02} from '../../designComponents/wrappers/FlexMainWrapper';
import {TopSideButton} from '../../designComponents/buttons/TopSideButton';
import RefreshCheckApi from '../../communication_system/axios_apis/refresh_check/refresh_check_api';
import {dateFilter} from '../../utils/textFilter';
import PolicyDetailModal from './PolicyDetailModal';
import {MainButton} from '../../designComponents/buttons/Buttons';

export const policyReadFailureSummary = (error) => {
    const status = Number.isInteger(error?.response?.status) ? error.response.status : null;
    const headers = error?.response?.headers;
    const runtimeHeader = typeof headers?.get === 'function' ? headers.get('x-sinor-admin-runtime') : headers?.['x-sinor-admin-runtime'];
    const runtime = typeof runtimeHeader === 'string' && runtimeHeader.length > 0 ? runtimeHeader.slice(0, 64) : null;
    const authStageHeader = typeof headers?.get === 'function' ? headers.get('x-sinor-admin-auth-stage') : headers?.['x-sinor-admin-auth-stage'];
    const authStage = authStageHeader === 'jwt' || authStageHeader === 'account' ? authStageHeader : null;
    const authReasonHeader = typeof headers?.get === 'function' ? headers.get('x-sinor-admin-auth-reason') : headers?.['x-sinor-admin-auth-reason'];
    const safeAuthReasons = ['header', 'signature', 'expired', 'not-before', 'environment', 'claims', 'token'];
    const authReason = safeAuthReasons.includes(authReasonHeader) ? authReasonHeader : null;

    return { status, runtime, authStage, authReason };
};

// 포인트 테이블
function PolicyTable({}) {
    const tableRef = useRef();
    const [detailVisible, setDetailVisible] = useState(false);
    const [selectedPolicy, setSelectedPolicy] = useState(null);
    const [loadFailed, setLoadFailed] = useState(false);
    const [requestGeneration, setRequestGeneration] = useState(0);
    const callApi = useCallback(async () => {
        try {
            const response = await RefreshCheckApi.get('/adminPolicy');
            return response.data.data;
        } catch (error) {
            const failure = policyReadFailureSummary(error);
            console.error(
                '정책 목록을 불러오지 못했습니다.',
                `status=${failure.status ?? 'unknown'} runtime=${failure.runtime ?? 'unknown'} auth_stage=${failure.authStage ?? 'unknown'} auth_reason=${failure.authReason ?? 'unknown'}`,
            );
            setLoadFailed(true);
            return [];
        }
    }, []);
    const [refresh, setRefresh] = useState(false);
    useEffect(() => {
        if (!detailVisible) {
            setSelectedPolicy(null);
        }
    }, [detailVisible]);
    return (
        <>
            <Wrapper02>
                <FlexMainWrapper>
                    {loadFailed ? (
                        <FlexMainWrapper
                            style={{
                                alignItems: 'center',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                minHeight: '240px',
                                width: '98%',
                            }}
                        >
                            <strong>정책 내역을 불러오지 못했습니다.</strong>
                            <span>잠시 후 다시 시도해 주세요.</span>
                            <MainButton
                                type="button"
                                text="다시 불러오기"
                                onClick={() => {
                                    setLoadFailed(false);
                                    setRequestGeneration((generation) => generation + 1);
                                }}
                            />
                        </FlexMainWrapper>
                    ) : (
                        <MainTable
                            key={requestGeneration}
                            toggleBlur={true}
                            checkAble={false}
                            buttonComponents={({ checkItems, setCheckItems }) => (
                                <FlexMainWrapper style={{ alignItems: 'center', justifyContent: 'end' }}>
                                    <TopSideButton
                                        middleOn={false}
                                        rightOn={false}
                                        onClick={() => {
                                            setDetailVisible(true);
                                        }}
                                    />
                                </FlexMainWrapper>
                            )}
                            rendering={refresh}
                            tableStyle={{ width: '98%' }}
                            tableRef={tableRef}
                            loadingText={'정책 내역을 불러오고 있습니다.'}
                            headerData={[
                                {
                                    key: 'id',
                                    value: 'ID',
                                },
                                {
                                    key: 'title',
                                    value: '이름',
                                },
                                {
                                    key: 'createdAt',
                                    value: '생성일',
                                },
                            ]}
                            callApi={callApi}
                            pagenaitionOn={false}
                            onClickRowItem={(item) => () => {
                                setSelectedPolicy(item);
                                setDetailVisible(true);
                            }}
                            tbodyRenderItem={(key, value) => {
                                if (key === 'createdAt') {
                                    return dateFilter(new Date(value), 'YYYY-MM-DD');
                                }
                                return value;
                            }}
                        />
                    )}
                </FlexMainWrapper>
            </Wrapper02>

            <PolicyDetailModal
                onUpdate={() => {
                    setRefresh(!refresh);
                }}
                item={selectedPolicy}
                visible={detailVisible}
                setVisible={setDetailVisible}
            />
        </>
    );
}

export default PolicyTable;
